import { useSession } from "./useSession";
import type { Resource, ResourceAction, AdminAction } from "../types/domain";

// Зеркало серверного requirePermission. Возвращает true, если у текущего
// пользователя есть указанное право. Для admin-action: usePermission("admin",
// "manageRoles"). Для ресурса: usePermission("launches", "create").
//
// Если permissions ещё не загружены (session loading) — возвращаем false,
// чтобы не показывать write-UI до подтверждения от сервера.
export function usePermission(
  resource: Resource | "admin",
  action: ResourceAction | AdminAction,
): boolean {
  const session = useSession();
  const perms = session.data?.permissions;
  if (!perms) return false;
  if (resource === "admin") {
    return perms.admin?.[action as AdminAction] === true;
  }
  const sub = perms[resource];
  return sub?.[action as ResourceAction] === true;
}
